import type html2pdf from 'html2pdf.js';

import {AfriexTransactionType} from '@/types';
import type {BusinessTransactionType} from '@/types/AfriexBusinessTransactionType';

/**
 * The options object html2pdf.js's `Worker.set()` accepts. Its bundled
 * `Html2PdfOptions` is not exported and omits several options the runtime does
 * accept (`pagebreak`, `jsPDF.hotfixes`, `jsPDF.compress`), so recover it from
 * the worker signature and add the missing keys once here rather than casting
 * the option object at each receipt button.
 */
export type Html2PdfOptions = Parameters<
  InstanceType<typeof html2pdf.Worker>['set']
>[0] & {
  pagebreak?: {mode?: string | string[]};
  jsPDF?: {hotfixes?: string[]; compress?: boolean};
};

export function removeDarkClasses(element: HTMLElement) {
  const classList = element.className?.toString?.();

  if (typeof classList === 'string') {
    element.className = classList
      .split(' ')
      .filter((cls) => !cls.startsWith('dark:'))
      .join(' ');
  }

  Array.from(element.children).forEach((child) => {
    // Recurse only if child is HTMLElement
    if (child instanceof HTMLElement) {
      removeDarkClasses(child);
    }
  });
}

export const removePayazaIfGHS = (root: HTMLElement) => {
  //check for GHS anywhere inside the receipt
  if (!root.textContent?.includes('GHS')) {
    return;
  }

  const blocks = root.querySelectorAll('div');

  blocks.forEach((block) => {
    const ps = block.querySelectorAll('p');
    if (ps.length >= 2) {
      const label = ps[0].textContent?.trim().toLowerCase();
      const value = ps[1].textContent?.trim().toLowerCase();

      if (label === 'processor' && value === 'payaza') {
        block.remove();
      }
    }
  });
};

export const getReceiptTransactionFileName = (
  type: AfriexTransactionType | BusinessTransactionType | undefined,
) => {
  switch (type) {
    case AfriexTransactionType.WITHDRAW:
      return 'receipt_withdraw';
    case AfriexTransactionType.DEPOSIT:
      return 'receipt_deposit';
    case AfriexTransactionType.TRANSFER:
      return 'receipt_transfer';
    default:
      return 'receipt_transaction';
  }
};
